"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ui_1 = require("@vidazoo/ui");
var selfTheme = require("../reportingList/theme.scss");
var ReportGroupValueCell_1 = require("./ReportGroupValueCell");
var ReportFieldValueCell_1 = require("./ReportFieldValueCell");
var ReportingRow = /** @class */ (function (_super) {
    tslib_1.__extends(ReportingRow, _super);
    function ReportingRow(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onQuickConstraint = function (item) {
            var onQuickConstraint = _this.props.onQuickConstraint;
            onQuickConstraint(item);
        };
        return _this;
    }
    ReportingRow.prototype.render = function () {
        var _this = this;
        var _a = this.props, index = _a.index, columnsWidth = _a.columnsWidth, freezeColumnIndex = _a.freezeColumnIndex, item = _a.item, onQuickConstraint = _a.onQuickConstraint, onQuickFilter = _a.onQuickFilter, setFreezeColumn = _a.setFreezeColumn, onSort = _a.onSort, onSearch = _a.onSearch, sortDirection = _a.sortDirection;
        var dataGridColumnIndex = -1;
        return (React.createElement(ui_1.DataGridRow, { className: selfTheme.row, index: index, columnsWidth: columnsWidth, key: index, freezeColumnIndex: freezeColumnIndex },
            item.groups.map(function (group) {
                dataGridColumnIndex++;
                return (React.createElement(ui_1.DataGridColumn, { key: group.name, density: null },
                    React.createElement(ReportGroupValueCell_1.default, { onSearch: onSearch, sortDirection: sortDirection, onSort: onSort, enableQuickFilter: group.hasFilterType, group: group, quickFilter: onQuickFilter, dataGridColumnIndex: dataGridColumnIndex, freezeColumnIndex: freezeColumnIndex, setFreezeColumn: setFreezeColumn })));
            }),
            item.fields.filter(function (field) { return field.isRequested; }).map(function (field) {
                dataGridColumnIndex++;
                return (React.createElement(ui_1.DataGridColumn, { key: field.name, density: null },
                    React.createElement(ReportFieldValueCell_1.default, { dataGridColumnIndex: dataGridColumnIndex, sortDirection: sortDirection, onSort: onSort, freezeColumnIndex: freezeColumnIndex, setFreezeColumn: setFreezeColumn, key: field.name, field: field, onQuickConstraint: _this.onQuickConstraint })));
            })));
    };
    ReportingRow.defaultProps = {};
    return ReportingRow;
}(React.Component));
exports.default = ReportingRow;
